import React from 'react';
import {
  FDBox,
} from '@facet-wealth/design';
import DesiredOutcomesSectionPicker from './DesiredOutcomesSectionPicker';

const DesiredOutcomes = () => {
  return (
    <FDBox padding={2}>
      <DesiredOutcomesSectionPicker />
    </FDBox>
  );
};


DesiredOutcomes.propTypes = {
};

export default DesiredOutcomes;
